import { post } from "./utils.service";

export const generatePromotionalCodes = async (body) => {
  return await post("/promotional-codes/generate", body);
};
